import React from 'react';

const TestModeRedBar = () => (
	<div style={{ backgroundColor: '#FF0000', textAlign: 'center', height: 25 }}>
		Test System - SilverAgent
	</div>
);

export default TestModeRedBar;
